import {navigate} from 'gatsby';
import {isBrowser} from '../browserSupport';

const redirectByQueryParam = (defaultRedirect = '/'): void => {
  const queryParams = new URLSearchParams(window.location.search);
  const redirectTo = decodeURIComponent(queryParams.get('r') || defaultRedirect);
  // only navigate on browsers (not SSR)
  if (isBrowser) {
    navigate(redirectTo);
  }
};

export default redirectByQueryParam;
